import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { AppRoles } from '../constants/appRoles.ts';
import { ApplicationRoutes } from '../constants/appRoutes.ts';
import { Layout } from '../components/layout/layout.tsx';

export const ManageLiveSaleRoutes: RouteItem = {
  text: 'Live Sale Editor',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.Admin],
  path: ApplicationRoutes.crm.liveSales,
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/liveSales/ManageLiveSales.tsx');
    return { Component: component.ManageLiveSales };
  }
};
